import {
  ScrollDirection,
  useScrollDirection,
} from "src/hooks/useScrollDirection";
import { useScrolledDown } from "src/hooks/useScrolledDown";

export function useMinimizeHeader() {
  const scrollDirection = useScrollDirection({ threshold: 10 });
  const isScrolledDown = useScrolledDown({ minY: 50 });
  return (
    isScrolledDown &&
    (scrollDirection || ScrollDirection.UP) === ScrollDirection.DOWN
  );
}
